let CustomEvent = self.CustomEvent;

try
{
	const customEvent = new CustomEvent('test', {cancelable: true});
	customEvent.preventDefault();
	if (customEvent.defaultPrevented !== true)
	{
		// noinspection ExceptionCaughtLocallyJS
		throw new Error();
	}
}
catch (e)
{
	CustomEvent = function(eventType, options)
	{
		options = options || {};
		const customEvent = document.createEvent('CustomEvent');
		customEvent.initCustomEvent(eventType, options.bubbles, options.cancelable, options.detail);

		customEvent.preventDefault = function(preventDefault)
		{
			preventDefault.call(customEvent);

			Object.defineProperty
			(
				customEvent,
				'defaultPrevented',
				{
					get: function()
					{
						return options.cancelable && true
					}
				}
			);
		}
		.bind(null, customEvent.preventDefault);

		return customEvent;
	}
}

export default CustomEvent;